import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@mui/material';
import { ITable } from '../iComponents/iTable/ITable';
import { useSelector, useDispatch } from 'react-redux';
import { getComodityListByPO } from '../../../store/POcomparison/actions';

import '../iComponents/iTable/Itable.scss';

const POcomparison = ({ selectedRow, milestoneConfig, isActive }: any) => {
    const groupName = 'POcomparison';
    const dispatch = useDispatch();
    const { data, isLoading } = useSelector((state: any) => state.POcomparison);

    const [form, setForm] = useState({
        from: '',
        to: '',
        dynamicFilter: '',
    });
    const [tableValue, setTableValue] = useState([]);
    const [totalDetails, setTotalDetails] = useState<any>({});
    const [comodities, setComodities] = useState<any>([]);
    const [columns, setColumns] = useState<any>([
        { text: 'PartNumber', dataField: 'PartNumber' },
        {
            text: 'Description',
            dataField: 'Description',
            footer: 'TOTALS',
        },
        {
            text: 'Available',
            dataField: 'AvailablePieces',
            footer: totalDetails.totalAvailablePieces,
        },
        {
            text: 'Expected',
            dataField: 'ExpectedPieces',
            footer: totalDetails.totalExpectedPieces,
        },
        {
            text: 'Discrepancy',
            dataField: 'Discrepancy',
            footer: totalDetails.totalDiscrepancyPieces,
        },
    ]);
    const [pagination, setPagination] = useState<any>({
        sizePerPage: 1000,
        page: 1,
    });

    useEffect(() => {
        if (isActive) {
            dispatch(getComodityListByPO({ number: selectedRow.Number, form, pagination }));
        }
    }, [dispatch, selectedRow.Number, pagination, form, isActive]);

    useEffect(() => {
        const grouped = groupBy(data, (item: any) => item.PartNumber);
        setComodities(grouped);
    }, [data]);

    useEffect(() => {
        const { data, totalAvailableItems, totalExpectedItems, supplierPONumber, wRNumber } = formatTableData(comodities);
        let totalDiscrepancyPieces = 0;
        const newArray = data?.map((item: any) => {
            const discrepancy = item.orderItem.AvailablePieces - item.orderItem.ExpectedPieces;
            totalDiscrepancyPieces = totalDiscrepancyPieces + discrepancy;
            return {
                PartNumber: item?.orderItem?.PartNumber,
                Description: item?.orderItem?.Description,
                ExpectedPieces: item?.orderItem?.ExpectedPieces,
                AvailablePieces: item?.orderItem?.AvailablePieces,
                Discrepancy: discrepancy,
            };
        });

        setColumns([
            {
                text: 'PartNumber',
                dataField: 'PartNumber',
                footer: '',
                footerClasses: 'footerTable',
            },
            {
                text: 'Description',
                dataField: 'Description',
                footer: 'TOTALS',
                footerClasses: 'footerTable',
            },
            {
                text: 'Available',
                dataField: 'AvailablePieces',
                footer: `${totalAvailableItems}`,
                footerClasses: 'footerTable',
            },
            {
                text: 'Expected',
                dataField: 'ExpectedPieces',
                footer: `${totalExpectedItems}`,
                footerClasses: 'footerTable',
            },
            {
                text: 'Discrepancy',
                dataField: 'Discrepancy',
                footer: `${totalDiscrepancyPieces}`,
                footerClasses: 'footerTable',
            },
        ]);
        setTotalDetails({
            supplierPONumber: supplierPONumber,
            wRNumber: wRNumber,
        });
        setTableValue(newArray);
    }, [comodities]);

    const groupBy = (list: any, keyGetter: any) => {
        const map = new Map();
        list?.forEach((item: any) => {
            const key = keyGetter(item);
            if (key) {
                const collection = map.get(key);
                if (!collection) {
                    map.set(key, [item]);
                } else {
                    collection.push(item);
                }
            }
        });
        return map;
    };

    const formatTableData = (tableData: any) => {
        const newData: any = [];
        let totalAvailableItems = 0;
        let totalExpectedItems = 0;
        let supplierPONumber = '';
        let wRNumber = '';
        tableData?.forEach((value: any, key: any) => {
            let values = {
                key: key,
                orderItem: {},
            };
            let availablePieces = 0;
            let expectedPieces = 0;
            value.forEach((item: any) => {
                if (item.SupplierPONumber && !supplierPONumber) {
                    supplierPONumber = item.SupplierPONumber;
                }
                if (item.WarehouseReceiptNumber && !wRNumber) {
                    wRNumber = item.WarehouseReceiptNumber;
                }
                if (item.PurchaseOrderGUID === '' || item.WarehouseReceiptNumber !== null) {
                    availablePieces = availablePieces + item.Pieces;
                    totalAvailableItems = totalAvailableItems + item.Pieces;
                }

                if (item.PurchaseOrderGUID !== '') {
                    expectedPieces = expectedPieces + item.Pieces;
                    totalExpectedItems = totalExpectedItems + item.Pieces;
                }
                values = {
                    ...values,
                    orderItem: {
                        ...values.orderItem,
                        AvailablePieces: availablePieces,
                        ExpectedPieces: expectedPieces,
                        ...item,
                    },
                };
            });
            newData.push(values);
        });
        return {
            data: newData,
            totalExpectedItems: totalExpectedItems,
            totalAvailableItems: totalAvailableItems,
            supplierPONumber: supplierPONumber,
            wRNumber: wRNumber,
        };
    };

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    return (
        <div style={{ maxHeight: 475, maxWidth: '100%', overflow: 'auto' }}>
            {tableValue.length !== 0 ? (
                !isLoading ? (
                    <Typography sx={{ fontWeight: 700, display: 'flex', marginLeft: 3 }}>
                        WR / PO #:{' '}
                        <Typography>
                            {totalDetails.wRNumber} / {totalDetails.supplierPONumber}
                        </Typography>
                    </Typography>
                ) : null
            ) : null}
            <ITable
                valuesSizePagination={[1000]}
                remote={true}
                //handlerPaginationState={handlePaginationChange}
                isLoading={isLoading}
                data={tableValue}
                fields={milestoneConfig}
                tableColumns={columns}
                CountItems={tableValue.length}
                headerColorT={'bg-primary text-white'}
                ShowViewlistCommodity={false}
                groupName={groupName}
            />
        </div>
    );
};

POcomparison.propTypes = {
    selectedRow: PropTypes.shape({
        Number: PropTypes.string,
        SellerName: PropTypes.string,
    }),
    milestoneConfig: PropTypes.shape({
        Number: PropTypes.string,
        SellerName: PropTypes.string,
        OperationName: PropTypes.string,
        OperationType: PropTypes.string,
        dataField: PropTypes.string,
        isMilestone: PropTypes.bool,
        order: PropTypes.string,
        text: PropTypes.string,
        userId: PropTypes.string,
        visibleInMiddle: PropTypes.bool,
        visibleInModalFooter: PropTypes.bool,
        visibleInModalHeader: PropTypes.bool,
        visibleInTable: PropTypes.bool,
        hidden: PropTypes.bool,
        visibleInModalBody: PropTypes.bool,
        visibleInModalTotal: PropTypes.bool,
    }),
    isActive: PropTypes.bool.isRequired
};

export default POcomparison;
